import { ImageContainer, MainContainer } from "ui"
import { extractProperty } from "utils"

type Props = {
  data: any
}

function ImageWithContainer({ data }: Props) {
  const desktopUrl = extractProperty(data, "desktopImage")
  const mobileUrl = extractProperty(data, "mobileImage")

  return (
    <MainContainer rightGap={150}>
      <ImageContainer
        desktopUrl={desktopUrl}
        mobileUrl={mobileUrl}
        height={546}
        largeHeight={820}
        mobileHeight={420}
        emptyAlt
      />
    </MainContainer>
  )
}

export default ImageWithContainer
